import TableTextFilter from "../../controls/table/TextFilter";
import { getSafe } from "../../util/storeHelper";
import { SITE_ID } from "../gamemode_management/constants";
import EndorseModButton from "../nexus_integration/views/EndorseModButton";
import * as React from "react";
function renderLoadFailure(t, fail) {
    const pattern = getSafe({
        "unsupported-version": "Not compatible with this version of Vortex",
        "unsupported-api": "Unsupported API",
        dependency: fail.args?.["version"] !== undefined
            ? 'Depends on "{{dependencyId}}" version "{{version}}"'
            : 'Depends on "{{dependencyId}}"',
        exception: "Failed to load: {{message}}",
    }, [fail.id], "Unknown error");
    return t(pattern, { replace: fail.args });
}
function createEndorsedIcon(ext, onEndorse, t) {
    const endorsed = ext.endorsed || "Undecided";
    return (React.createElement(EndorseModButton, { endorsedStatus: endorsed, t: t, gameId: SITE_ID, modId: ext.modId.toString(), onEndorseMod: onEndorse }));
}
function getTableAttributes(context) {
    return [
        {
            id: "enabled",
            name: "Status",
            description: "Is the extension enabled",
            icon: "check-o",
            calc: (extension) => {
                switch (extension.enabled) {
                    case true:
                        return "Enabled";
                    case false:
                        return "Disabled";
                    case "failed":
                        return "Failed";
                }
            },
            placement: "table",
            isToggleable: false,
            edit: {
                inline: true,
                choices: () => [
                    { key: "enabled", text: "Enabled" },
                    { key: "disabled", text: "Disabled" },
                    { key: "failed", text: "Failed", visible: false },
                ],
                onChangeValue: (extension, value) => value === undefined
                    ? context.onToggleExtensionEnabled(extension.name)
                    : context.onSetExtensionEnabled(extension.name, value === "enabled"),
            },
            isSortable: false,
            isGroupable: true,
        },
        {
            id: "name",
            name: "Name",
            description: "Extension Name",
            icon: "quotes",
            calc: (extension) => extension.name,
            placement: "table",
            isToggleable: false,
            edit: {},
            isSortable: true,
            filter: new TableTextFilter(true),
        },
        {
            id: "endorsed",
            name: "Endorsed",
            description: "Endorsement state on Nexus",
            icon: "star",
            calc: (extension) => extension.endorsed,
            customRenderer: (extension, detail, t) => !!extension.modId
                ? createEndorsedIcon(extension, context.onEndorseMod, t)
                : null,
            placement: "table",
            isToggleable: true,
            edit: {},
            isSortable: true,
            isGroupable: true,
        },
        {
            id: "author",
            name: "Author",
            description: "Extension Author",
            icon: "a-edit",
            calc: (extension) => extension.author,
            placement: "table",
            isToggleable: true,
            edit: {},
            isSortable: true,
            isGroupable: true,
        },
        {
            id: "description",
            name: "Description",
            description: "Extension Description",
            placement: "detail",
            customRenderer: (extension) => (React.createElement("textarea", { className: "textarea-details", value: extension.description, readOnly: true })),
            calc: (extension) => extension.description,
            edit: {},
        },
        {
            id: "version",
            name: "Version",
            description: "Extension Version",
            icon: "cake",
            placement: "table",
            calc: (extension) => extension.version,
            isToggleable: true,
            edit: {},
            isSortable: false,
        },
        {
            id: "errors",
            name: "Load Errors",
            description: "Errors when loading this extension",
            icon: "bug",
            placement: "detail",
            calc: (extension, t) => extension.loadFailures
                .map((fail) => renderLoadFailure(t, fail))
                .join("\n"),
            customRenderer: (extension, detailCell, t) => (React.createElement("textarea", { className: "textarea-details", value: extension.loadFailures
                    .map((fail) => renderLoadFailure(t, fail))
                    .join("\n"), readOnly: true })),
            edit: {},
        },
    ];
}
export default getTableAttributes;
